import Vue from 'vue'
import MtsUI from '@mts-ui/core'
import '@mts-ui/core/src/assets/sprite.svg'
import '@mts-ui/core/dist/mts-ui.core.css'

Vue.use(MtsUI)
